module.exports = __webpack_public_path__ + "img/check_sign.20d6b20f.svg";